<template>
  <nx-auth-card
    :title="$t('message.login.loginPageTitle')"
    login-method="google-login"
    v-on="$listeners"
  >
    <ds-text
      v-html="$t('message.login.oauthInfo')"
    />
    <v-btn
      :loading="loading"
      block
      class="text-none"
      outline
      @click.prevent="submit"
    >
      <v-icon left>
        $vuetify.icons.google
      </v-icon>
      {{ $t('message.login.googleLogin') }}
    </v-btn>
    <p
      v-if="error"
      class="text-xs-center error--text"
      v-text="error"
    />
  </nx-auth-card>
</template>

<script>
import { mapGetters } from 'vuex';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import { LOGIN_PAGE_ID_LOGIN } from '@/modules/authentication/config/login-routes';
import AuthComponent from '@/modules/authentication/mixins/auth-component';

export default {
  name: 'NxAuthGoogleLogin',
  components: {
    NxAuthCard,
  },
  mixins: [AuthComponent],
  data() {
    return {
      error: null,
    };
  },
  computed: {
    ...mapGetters(['bootstrap']),
  },
  mounted() {
    if (!this.bootstrap.staffGoogleLoginClientId) {
      this.goToUserPasswordLogin();
      return;
    }

    this.googleClient = google.accounts.oauth2.initTokenClient({
      client_id: this.bootstrap.staffGoogleLoginClientId,
      scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
      callback: this.googleLogin,
    });
  },
  methods: {
    requestAccessTokenError() {
      return this.$t('message.login.googleOauthError');
    },
    userNotConnected() {
      return this.$t('message.login.googleNotLinked');
    },
    async submit() {
      if (this.loading) {
        return;
      }

      this.error = null;
      try {
        const result = await this.dispatch('authentication/GOOGLE_LOGIN');
        if (result.success) {
          return;
        }

        if (result.apiCode === 'google-error') {
          this.error = this.requestAccessTokenError();
        } else {
          this.error = this.userNotConnected();
        }
      } catch (e) {
        console.warn('Error login with Google:');
        console.error(e);
      }
    },
    goToUserPasswordLogin() {
      this.redirectToLoginPage(LOGIN_PAGE_ID_LOGIN);
    },
  },
};
</script>
